import { Fragment } from "react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import LinksBar from "../LinksBar";
import FormAgrupamento from "./FormAgrupamento";
import Caracteristicas from "./Caracteristicas";
import { actions } from "../../../redux/actions";
import * as s from "./formgraficoevolucaogenetica.module.css";
import VisualizacaoGrafico from "../Grafico/VisualizacaoGrafico";
import { ConsultaInterface } from "../interfaces/ConsultaInterface";
import FormPesquisaFiltroAvancado from "./FormPesquisaFiltroAvancado";
import { FormGraficoEvolucaoGeneticaProps } from "../interfaces/FormGraficoEvolucaoGeneticaProps";

const FormGraficoEvolucaoGenetica: React.FC<FormGraficoEvolucaoGeneticaProps> = ({
  fazendas,
  racas,
  sexos,
  categorias,
  variedades,
  caracteristicas,
  graphData,
  send,
  onRacaSelected,
  initialConsulta,
  paises,
}) => {
  const dispatch = useDispatch();
  const { page_filter } = useSelector((state: any) => state);

  const [consulta, setConsulta] = useState(initialConsulta);
  const [error, setError] = useState(false);
  const [loadingFichaAnimal, setLoadingFichaAnimal] = useState(false);

  const handleConsulta = (obj: ConsultaInterface) => {
    if (obj && Object.keys(obj).length > 0) {
      Object.keys(obj).map(function (key, index) {
        setConsulta({ ...consulta, [key]: obj[key] });
        return obj;
      });
    }
  };
  const handleSubmit = () => {
    send(consulta);
  };

  const handleLink = (value: any) => {
    dispatch(actions.addNewPageFilter(value));
  };

  return (
    <Fragment>
      <div className={s.header}>
        <LinksBar active={page_filter} handleLink={handleLink} />
      </div>

      {page_filter === "filtro" && (
        <div className="btn-container">
          <a
            href="/submodulos/2"
            className="global-btn-info shadow-none text-decoration-none"
          >
            Voltar
          </a>

          <button
            className="global-btn-info shadow-none justify-content-center"
            onClick={handleSubmit}
            style={{ width: 197 }}
          >
            Filtrar
          </button>
        </div>
      )}
      {error && <span className="error-list">{error && error}</span>}

      {page_filter === "filtro" && (
        <>
          <FormPesquisaFiltroAvancado
            fazendas={fazendas}
            racas={racas}
            // caracteristicas={caracteristicas}
            handleConsulta={handleConsulta}
            onRacaSelected={onRacaSelected}
          />

          <Caracteristicas
            caracteristicas={caracteristicas}
            handleConsulta={handleConsulta}
          />

          <FormAgrupamento
            sexos={sexos}
            variedades={variedades}
            categorias={categorias}
            handleConsulta={handleConsulta}
            paises={paises}
          ></FormAgrupamento>
        </>
      )}

      {page_filter === "grafico" && (
        <VisualizacaoGrafico graphData={graphData}></VisualizacaoGrafico>
      )}
    </Fragment>
  );
};

export default FormGraficoEvolucaoGenetica;
